import {
  Box,
  Skeleton,
  Typography,
  TypographyOwnProps,
  styled,
  Stack
} from "@mui/material";
import BaseTooltip from "@ui/atoms/BaseTooltip/BaseTooltip";
import Icon from "@ui/atoms/Icon/Icon";

export const Label = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "required"
})<{
  component?: React.ElementType;
  required?: boolean;
  htmlFor?: string;
}>(({ required, theme }) => ({
  color: theme.vars.palette.text.tertiary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  marginBottom: 8,
  position: "relative",
  textAlign: "left",
  ...(required && {
    "&::after": {
      color: theme.vars.palette.error.main,
      content: '"*"',
      marginLeft: "2px"
    }
  })
}));

export type Props = TypographyOwnProps & {
  loading: boolean;
  required?: boolean;
  tooltipText?: string | React.ReactNode;
  component?: React.ElementType;
  htmlFor?: string;
  /** Lets a field point `aria-labelledby`/`labelId` at this label. */
  id?: string;
};

export const BaseFormLabel = (props: Props) => {
  const { children, loading, tooltipText, ...otherProps } = props;

  const formLabel = <Label {...otherProps}>{children}</Label>;

  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        width={100}
        height={20}
        sx={{ marginBottom: 1 }}
      />
    );
  }

  return tooltipText ? (
    <Stack
      direction="row"
      sx={{
        alignItems: "flex-start"
      }}
    >
      {formLabel}
      <BaseTooltip title={tooltipText}>
        <Box
          sx={{
            cursor: "pointer",
            display: "inline-block",
            ml: 0.5
          }}
        >
          <Icon name="info" size="sm" />
        </Box>
      </BaseTooltip>
    </Stack>
  ) : (
    formLabel
  );
};
